import { createFileRoute } from "@tanstack/react-router";
import { NotificationSettings } from "@/components/push/NotificationSettings";

export const Route = createFileRoute("/_authenticated/portal/notification-settings")({
  component: PortalNotificationSettings,
});

function PortalNotificationSettings() {
  return (
    <div className="space-y-6">
      <header>
        <p className="text-amber-300 text-[11px] tracking-[0.3em] uppercase font-semibold">Settings</p>
        <h1 className="font-serif text-4xl text-white mt-1">Notifications</h1>
        <p className="text-zinc-400 text-sm mt-2">Choose which updates you want to receive on this device.</p>
      </header>
      <NotificationSettings portal="customer" />
    </div>
  );
}